import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Grid, Link, Typography, Tooltip } from '@material-ui/core';

const SimpleTextInfo: React.FC<SimpleTextInfoProps> = (props) => {
	const { compact, label, value, to, subTo, subValue, title = '', target, pathname } = props;
	const testidPrefix = label.toLowerCase();

	if (!value) return null;

	return (
		<Grid container item>
			<Grid item xs={compact ? 12 : 3} data-testid={`${testidPrefix}-label`}>
				<Typography variant='subtitle2'>{label}</Typography>
			</Grid>
			<Grid item xs={compact ? 12 : 9} data-testid={`${testidPrefix}-value`}>
				<Tooltip title={title} placement='bottom-start'>
					<>
						{pathname ? (
							<Link component={RouterLink} variant='body2' to={{ pathname: `${pathname}` }} color='secondary' target={target}>
								{value}
							</Link>
						) : to ? (
							<Link component={RouterLink} variant='body2' to={to} color='secondary'>
								{value}
							</Link>
						) : (
							<Typography variant='body2'>{value}</Typography>
						)}
						{subTo && (
							<Link component={RouterLink} variant='body2' to={subTo} color='primary'>
								{subValue}
							</Link>
						)}
					</>
				</Tooltip>
			</Grid>
		</Grid>
	);
};

export type SimpleTextInfoProps = {
	compact?: boolean;
	label: string;
	value: JSX.Element | string | number;
	to?: string;
	subTo?: string;
	subValue?: string;
	title?: string;
	target?: string;
	pathname?: string;
};

export default SimpleTextInfo;
